import React from 'react';

import styled from '@emotion/styled';
import { mq, green01, black01 } from '../../_style';
import { css } from '@emotion/core';

const Container = styled.div`
  ${mq.pc} {
    width: ${props => props.col === 1 ? `${222 / 960 * 100}%` : props.col === 3 ? `${(960 - 222 - 48) / 960 * 100}%` : '100%'};
    ${props => props.col === 1 && `margin-right: 48px;`}
  }
  h4 {
    border-left: 5px solid ${green01};
    color: ${black01};
    font-size: 18px;
    line-height: 1;
    letter-spacing: 0.03em;
    margin-bottom: 20px;
    padding-left: 9px;
    text-align: left;
  }
`;

const Row = styled.div`
  display: ${props => props.col === 1 ? 'block' : 'flex'};
  flex-wrap: wrap;
  margin: 0 ${props => props.col === 1 ? 0 : props.col === 3 ? '-6px' : '-12px'} ${props => props.col && '-12px'};
  ${mq.sp} {
    display: flex;
    margin: 0 -5px -11px;
    flex-wrap: wrap;
  }
  & > * {
    margin: 0 ${props => props.col === 1 ? 0 : props.col === 3 ? '6px' : '12px'} ${props => props.col && '12px'};
    ${mq.pc} {
      width: ${props => props.col === 1 ? '100%' : props.col === 3 ? 'calc((100% - 12px * 3) / 3)' : 'calc((100% - 24px * 6) / 6)'};
    }
    ${mq.sp} {
      margin: 0 5px;
      width: calc((100% - 10px * 3) / 3);
      margin-bottom: 11px;
    }
  }
`;

export default class BtnRow extends React.Component {
  render() {
    return (
      <Container col={this.props.col}>
        <h4>{this.props.label}</h4>
        <Row col={this.props.col}>{this.props.children}</Row>
      </Container>
    );
  }
}
